import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import { Link } from 'react-router-dom';
import { red, lightBlue, indigo } from "@material-ui/core/colors";
import moment from "moment";
import { useSelector } from "react-redux";
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import billingHistoryService from "../../service/e_billing-history-service";
import { store } from "../../../../helpers/store";
import { useEffect, useState } from "react";
import {cssuseStyles} from "../../e_billing-style";
import { Grid, Hidden, Typography } from '@material-ui/core';
import { grey } from "@material-ui/core/colors";
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { routePaths } from "../../../config/route-paths";
import { useTranslation } from 'react-i18next';
import {Skeleton} from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '50%',
    },
    container: {
        marginBottom: 10,
    },
    rowborder: {
        borderWidth: "1px",
        borderColor: theme.palette.eLight?.base,
        borderStyle: 'solid',
        "& .MuiTableCell-root": {
            padding:"4px 16px" + "!important",
            borderTopLeftRadius: "4px",
            borderBottom: 0
        }
    },
    rowborder1: {
        borderWidth: "1px",
        borderColor: theme.palette.eLight?.base,
        borderStyle: 'solid',
        "& .MuiTableCell-root": {
            borderTopLeftRadius: "4px",
            borderBottom: 0
        }
    },
   
    expansiontable: {
        borderWidth: "1px",
        borderColor: theme.palette.whiteColor.main,
        borderStyle: 'solid',
        borderRadius: "8px"
    },
    expansiontablefirstrow: {
        margin: "0px",
        borderWidth: "2px",
    },
    marginbetweenrows: {
        margin: "10px",
        borderWidth: "0px",
    },
    chargeamount: {
        color: red[600]
    },
    paymentamount: {
        color: theme.palette.eSecondary?.base,
        fontWeight:"bold"
    },
    amoutColorRed: {
        color: red[600] + " !important",
    },
    smpadding:{
        padding:"8px !important"
    },
    
    paddingDate: {
        color: theme.palette.tertiary.main + " !important",
    },
    topElement: {
        verticalAlign: "top !important",
        padding: "2% 0% !important",
    },
    paddingContent: {
        padding: "0% 1% 2% 1% !important",
        width: "100%",
        borderBottom:"0px"
    },
    
    borderNone: {
        border: "none !important",
        padding: "1% !important",
        minWidth: "100px !important",
        verticalAlign: "initial !important",
    },
    rowpadding:{
        padding:"5px 0 !important"
    },
    padding:{
        "& .MuiTableCell-root":{
            padding:"5px 8px"
        }
    },
    width20:{
        width:"20%"
    },
    width30:{
        width:"30%"
    },
    width100:{
        width:"100%"
    },
    padding3:{
        padding:"0%"
    },
    linkpay: {
        color: theme.palette.ePrimary?.base,
        textDecorationLine: 'underline',
       
        "&:hover": {
            color: theme.palette.ePrimary?.hover,
        }
    },
}));

function Tablesrows({ row, tabName, collapseRows: changeInParent, type, currency }) {
    const classes=cssuseStyles();
    const useStyleClasses = useStyles();
    const TYPE_POSTPAID="postpaid";
    const PAYMENT_SUCCESS="FROZEN"
    const PAYMENT_CANCELLED="CANCELED"
    const [open, setOpen] = React.useState(false);
    const {t:billHistoriLabels, ready: billHistoryLabelReady} = useTranslation("label-E_BILLS_CHARGES_AND_PAYMENTS");
    const {t:prepaidChargePaymentLabels}=useTranslation("label-PREPAID_CHARGES_AND_PAYMENTS");
    const {t: payLabels} = useTranslation("label-BILLING_HISTORY");
    let contentTitle = `${useStyleClasses.borderNone}`;
    const [linkData, setLinkData] = useState([]);
    const primaryIdentifier = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.PRIMARY_IDENTIFIER);
    const accountId = store.getState().meterDetails.accountId;
    const primarylanguageCode = store.getState()?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE;
    let dateFormat = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.E_DATE_MONTH_YEAR_FORMAT)
    const [prePaymentFields, setPrePaymentFields] = useState([
        { key: "", fieldNo: 0, isAmount: false, display: true },
        { key: "E_PAYMENT_FIELD_MODE", fieldNo: 1, isAmount: false, display: true },
        { key: "E_PAYMENT_FIELD_PAY_EVENT_ID", fieldNo: 2, isAmount: false, display: true },
        { key: "E_PAYMENT_FIELD_PAY_ID", fieldNo: 3, isAmount: false, display: false },
        { key: "E_PAYMENT_FIELD_CARD_TYPE", fieldNo: 4, isAmount: false, display: true },
        { key: "E_PAYMENT_FIELD_CARD_NUMBER", fieldNo: 5, isAmount: false, display: true },
        { key: "E_PAYMENT_FIELD_CHECK_NUMBER", fieldNo: 6, isAmount: false, display: true },
        { key: "E_PAYMENT_FIELD_ENERGY_COST", fieldNo: 9, isAmount: true, display: true },
        { key: "E_PAYMENT_FIELD_REBATE1", fieldNo: 7, isAmount: true, display: true },
        { key: "E_PAYMENT_FIELD_PAIDDEBT", fieldNo: 14, isAmount: true, display: true },
        { key: "E_PAYMENT_FIELD_DEMAND_CHARGE", fieldNo: 8, isAmount: true, display: true },
        { key: "E_PAYMENT_FIELD_METER_RENT", fieldNo: 10, isAmount: true, display: true },
        { key: "E_PAYMENT_FIELD_VAT", fieldNo: 11, isAmount: true, display: true },
        { key: "E_PAYMENT_FIELD_PFC", fieldNo: 12, isAmount: true, display: true },
        { key: "E_PAYMENT_FIELD_ESTIMATEUNIT", fieldNo: 13, isAmount: false, display: true },
        { key: "E_PAYMENT_FIELD_TNDR_TYPE", fieldNo: 15, isAmount: false, display: true },
        { key: "E_PAYMENT_FIELD_TNDR_SOURCE_CD", fieldNo: 16, isAmount: false, display: true }
    ]);
    const [postPaymentFields, setPostPaymentFields] = useState([
        { key: "", fieldNo: 0, isAmount: false, display: true },
        { key: "E_PAYMENT_FIELD_MODE", fieldNo: 1, isAmount: false, display: true },
        { key: "E_PAYMENT_FIELD_PAY_EVENT_ID", fieldNo: 2, isAmount: false, display: true },
        { key: "E_PAYMENT_FIELD_PAY_ID", fieldNo: 3, isAmount: false, display: false },
        { key: "E_PAYMENT_FIELD_CARD_TYPE", fieldNo: 4, isAmount: false, display: true },
        { key: "E_PAYMENT_FIELD_CARD_NUMBER", fieldNo: 5, isAmount: false, display: true },
        { key: "E_PAYMENT_FIELD_CHECK_NUMBER", fieldNo: 6, isAmount: true, display: true  },
        { key: "E_PAYMENT_FIELD_DEPOSITE_AMOUNT", fieldNo: 9, isAmount: true, display: true  },
        { key: "E_PAYMENT_FIELD_NESCO_SUPPLIED_MATERIALS", fieldNo: 16, isAmount: true, display: true },
        { key: "E_PAYMENT_FIELD_CONTINGENCY_CHARGE", fieldNo: 8, isAmount: true, display: true  },
        { key: "E_PAYMENT_FIELD_APPLICATION_AMOUNT", fieldNo: 7, isAmount: true, display: true  },
        { key: "E_PAYMENT_FIELD_SERVICE_CHARGES", fieldNo: 18, isAmount: true, display: true },
        { key: "E_PAYMENT_FIELD_VAT_AMOUNT", fieldNo: 10, isAmount: true, display: true  },
        { key: "E_PAYMENT_FIELD_CUSTOMER_SUPPLIED_MATERIALS", fieldNo: 17, isAmount: true, display: true },
        { key: "E_PAYMENT_FIELD_TOTAL_AMOUNT", fieldNo: 11, isAmount: true, display: true  },
        { key: "PRINCIPAL_AMOUNT", fieldNo: 12, isAmount: true, display: false  },
        { key: "E_PAYMENT_FIELD_TNDR_TYPE", fieldNo: 13, isAmount: false, display: true },
        { key: "E_PAYMENT_FIELD_TNDR_SOURCE_CD", fieldNo: 14, isAmount: false, display: true },
        { key: "Contingency_Charge_15PER", fieldNo: 15, isAmount: true, display: false },
    ])
    useEffect(() => {
        setOpen(false)
    }, [changeInParent])
let PAY_ID="PAY_ID"
    return (
        <>
            <Hidden xsDown>
                {tabName === "payments" && row.label === "Payment" && (
                    <React.Fragment>
                        <TableRow className={useStyleClasses.rowborder} marginBottom={10} onClick={() => setOpen(!open)}>
                            <TableCell  className={`${useStyleClasses.rowpadding} ${useStyleClasses.width30}`}>
                                {moment(row.date.slice(0, 10)).format(dateFormat)}
                            </TableCell>
                            <TableCell className={useStyleClasses.width30} >
                            <>
                                {row.paymentStatus==PAYMENT_SUCCESS && billHistoryLabelReady &&
                                 <span className={classes.paymenttitle}>{billHistoriLabels("E_BILLING_PAYMENTRECEIVED")}</span>}
                                 {row.paymentStatus==PAYMENT_CANCELLED && billHistoryLabelReady &&
                                 <span className={classes.paymenttitle}>{billHistoriLabels("E_BILLING_PAYMENTCANCELLED")}</span>}
                            </> 
                            </TableCell>
                            <TableCell className={`${useStyleClasses.paymentamount} ${useStyleClasses.width20}`}>
                               {row.amount}
                            </TableCell>
                            <TableCell align='right' className={useStyleClasses.width20} >
                                <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                                    {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                </IconButton>
                            </TableCell>

                        </TableRow>  
                        <TableRow className={`${useStyleClasses.rowborder1} ${classes.paddingrow}`} >                   
                        {open ? <> <TableCell className={useStyleClasses.width20}> </TableCell>
                                <TableCell  colSpan={3}>
                                    {
                                        type === TYPE_POSTPAID ? postPaymentFields?.map((obj, index) => (
                                            row?.custom["field" + obj.fieldNo]?.value && obj.key && obj.display &&
                                            <TableRow >
                                            {
                                                billHistoryLabelReady ?
                                                <TableCell >{billHistoriLabels(obj.key)}</TableCell> :<Skeleton />
                                            }
                                                <TableCell >
                                                    {obj.isAmount && `${currency} `}
                                                    {row.custom["field" + obj.fieldNo].value}
                                                </TableCell>
                                            </TableRow>
                                        )) : prePaymentFields?.map((obj, index) => (
                                            row?.custom["field" + obj.fieldNo]?.value && obj.key && obj.display &&
                                            <TableRow >
                                            {
                                                billHistoryLabelReady ? <TableCell >{billHistoriLabels(obj.key)}</TableCell> : <Skeleton />
                                            }
                                                <TableCell >
                                                    {obj.isAmount && `${currency} `}
                                                    {row.custom["field" + obj.fieldNo].value}
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    }
                                    <TableRow >
                                        <TableCell colSpan={2}>
                                            <Link
                                            variant="caption"
                                            to={{
                                                pathname: `${routePaths.PAYMENT_RECEIPT}/${accountId}/${
                                                    row.custom.field3.name === PAY_ID
                                                        ? row.custom.field3.value
                                                        : row.custom.field2.name === PAY_ID &&
                                                        row.custom.field2.value}`,
                                                data: {
                                                    paymentId:
                                                        row.custom.field1.name === "PAY_EVENT_ID"
                                                            ? row.custom.field1.value
                                                            : row.custom.field2.name === "PAY_EVENT_ID" &&
                                                            row.custom.field2.value,
                                                    accountID: accountId,
                                                    currency: row.currency,
                                                    payId:
                                                        row.custom.field3.name === "PAY_ID"
                                                            ? row.custom.field3.value
                                                            : row.custom.field2.name === "PAY_ID" &&
                                                            row.custom.field2.value,
                                                },
                                            }}
                                            className={useStyleClasses.linkpay}
                                            >
                                            {
                                                billHistoryLabelReady ?
                                                <b>{billHistoriLabels("E_VIEW_PAYMENT")}</b>
                                                : <Skeleton />
                                            }
                                            </Link>
                                        </TableCell>
                                    </TableRow>
                                </TableCell>
                            </> :null}
                            </TableRow>

                        <hr className={useStyleClasses.marginbetweenrows} />
                    </React.Fragment>
                )}
            </Hidden>

            <Hidden smUp>
                {tabName === "payments" && row.label === "Payment" && (
                    <React.Fragment>
                        <TableRow onClick={() => { setOpen(!open) }} className={classes.mobileborder}>
                            <Typography
                                align="left"
                                className={useStyleClasses.smpadding}
                            >
                                <Grid container>
                                    <Grid item xs={3}>
                                        {moment(row.date.slice(0, 10)).format(dateFormat)}
                                    </Grid>
                                    <Grid container className={classes.paymenttitle} justify='center' item xs={5} > 
                                    {row.paymentStatus==PAYMENT_SUCCESS && billHistoryLabelReady &&
                                 <span >{billHistoriLabels("E_BILLING_PAYMENTRECEIVED")}</span>} 
                                  {row.paymentStatus==PAYMENT_CANCELLED && billHistoryLabelReady &&
                                 <span >{billHistoriLabels("E_BILLING_PAYMENTCANCELLED")}</span>}                                   
                                    </Grid>
                                    <Grid container item xs={3} justify='center' className={useStyleClasses.paymentamount}>
                                      {row.amount}
                                    </Grid>
                                    <Grid xs={1}>
                                        {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                    </Grid>
                                </Grid>
                            </Typography>
                            <TableRow > 
                                
                                <TableCell align="left" className={useStyleClasses.paddingContent} >
                                
                                    <Collapse in={open} timeout="auto">
                                       <Grid container>
                                            {
                                                type === TYPE_POSTPAID ? postPaymentFields?.map((obj, index) => (
                                                    row?.custom["field" + obj.fieldNo]?.value && obj.key && obj.display &&
                                                    <Grid item direction='row' container className={classes.fontContent}>
                                                    {
                                                        billHistoryLabelReady ?
                                                        <Grid xs={5} item className={`${contentTitle} ${useStyleClasses.rowpadding} ${classes.fontContent}`}>{billHistoriLabels(obj.key)}</Grid>
                                                        : <Skeleton />
                                                    }
                                                        <Grid xs={7} item className={`${useStyleClasses.borderNone} ${useStyleClasses.rowpadding}  ${classes.fontContent}`}>
                                                            {obj.isAmount && `${currency} `}
                                                            {row.custom["field" + obj.fieldNo].value}
                                                        </Grid>
                                                    </Grid>
                                                )) : prePaymentFields?.map((obj, index) => (
                                                    row?.custom["field" + obj.fieldNo]?.value && obj.key && obj.display &&
                                                    <Grid item direction='row' container className={classes.fontContent}>
                                                    {
                                                        billHistoryLabelReady ?
                                                        <Grid xs={5} item className={`${contentTitle} ${useStyleClasses.rowpadding} ${classes.fontContent}`}>{billHistoriLabels(obj.key)}</Grid>
                                                        : <Skeleton />
                                                    }
                                                        <Grid xs={7} item className={`${useStyleClasses.borderNone} ${useStyleClasses.rowpadding}  ${classes.fontContent}`}>
                                                            {obj.isAmount && `${currency} `}
                                                            {row.custom["field" + obj.fieldNo].value}
                                                        </Grid>
                                                    </Grid>
                                                ))
                                            }
                                                <Grid item direction='row' container  className={useStyleClasses.rowpadding}>
                                                    <Grid item className={`${classes.fontContent} ${useStyleClasses.width100}`}>
                                                    <>
                                                        { billHistoryLabelReady ? <Link
                                                            variant="caption"
                                                            to={{
                                                                pathname: `${routePaths.PAYMENT_RECEIPT}/${accountId}/${
                                                                    row.custom.field3.name === "PAY_ID"
                                                                        ? row.custom.field3.value
                                                                        : row.custom.field2.name === "PAY_ID" &&
                                                                        row.custom.field2.value}`,
                                                                data: {
                                                                    paymentId:
                                                                        row.custom.field1.name === "PAY_EVENT_ID"
                                                                            ? row.custom.field1.value
                                                                            : row.custom.field2.name === "PAY_EVENT_ID" &&
                                                                            row.custom.field2.value,
                                                                    accountID: accountId,
                                                                    currency: row.currency,
                                                                    payId:
                                                                        row.custom.field3.name === "PAY_ID"
                                                                            ? row.custom.field3.value
                                                                            : row.custom.field2.name === "PAY_ID" &&
                                                                            row.custom.field2.value,
                                                                },
                                                            }}
                                                            className={useStyleClasses.linkpay}
                                                        >
                                                            <b>{billHistoriLabels("E_VIEW_PAYMENT")}</b>
                                                        </Link> : <Skeleton /> }
                                                    </>
                                                    </Grid>
                                                </Grid>
                                       </Grid>
                                    </Collapse>
                                </TableCell>
                            </TableRow>
                        </TableRow>
                       
                    </React.Fragment>
                )}
            </Hidden>
        </>
    )
}
export default Tablesrows